module.exports = __webpack_public_path__ + "static/media/icon-chevon-left-white.3b6378f3.svg";